export default __webpack_public_path__ + "static/media/chrome-phone-apple-1.e71bfd33.png";